import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import BalanceTable from "../../components/common/BalanceTable";
import { getOutOfBalance } from "../../services/reportsService";

const OutOfBalance = () => {
  const [investmentBalance, setInvestmentBalance] = useState(0);
  const [loanBalance, setLoanBalance] = useState(0);
  const [cashBalance, setCashBalance] = useState(0);
  const [outOfBalance, setOutOfBalance] = useState(0);

  useEffect(() => {
    getOutOfBalance()
      .then((res) => {
        setInvestmentBalance(res?.investmentBalance);
        setLoanBalance(res?.loanBalance);
        setCashBalance(res?.cashBalance);
        setOutOfBalance(res?.outOfBalance);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      <Typography 
        variant="h4" 
        sx={{ 
          margin: "20px 40px",
          fontWeight: "bold"
        }}
      >
        Out of Balance
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "20px 0",
        }}
      >
        <BalanceTable
          investmentBalance={investmentBalance}
          loanBalance={loanBalance}
          cashBalance={cashBalance}
          outOfBalance={outOfBalance}
        />
      </Box>
    </>
  );
};

export default OutOfBalance;
